import React from 'react';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import store from './store';
import App from './App';
import './assets/css/ladda.min.css';
import './assets/css/style.css';
import './assets/css/style.scss';
import './assets/css/dpi.css';
import './assets/css/print.scss';
import './assets/css/mobileview.scss'
import 'react-phone-input-2/lib/style.css'
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import { createRoot } from 'react-dom/client';

const root = createRoot(document.getElementById('root'));

if (process.env.NODE_ENV !== 'development') {
  console.info = () => {};
  console.log = () => {};
  console.error = () => {};

}
// Remove the old caching service worker.
// An earlier build registered a Workbox service worker (public/service-worker.js)
// that cached the app shell and JS/CSS with a stale-while-revalidate strategy,
// which forced users to hard-reload to see the latest deploy. We no longer use it,
// so unregister it and drop its caches.
// NOTE: only that caching worker is removed. Firebase Cloud Messaging registers
// its own worker (firebase-messaging-sw.js) for push notifications — leave it be.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      const scriptURL =
        registration.active?.scriptURL ||
        registration.waiting?.scriptURL ||
        registration.installing?.scriptURL ||
        '';
      if (scriptURL.endsWith('/service-worker.js')) {
        registration.unregister();
      }
    });
  });

  if (window.caches) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        if (name.startsWith('my-cache') || name.startsWith('workbox')) {
          caches.delete(name);
        }
      });
    });
  }
}
// const root = createRoot(document.querySelector("#ecollat-entry"));
// root.render(<App />);
root.render(
  <Provider store={store}>
    <ToastContainer
      position="top-center"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      icon={({ type }) => {
        if (type === 'success')
          return (
            <img src="/manage/images/Toast-svg/Success.svg" className="imageSize" alt="Success" />
          );
        if (type === 'error')
          return <img src="/manage/images/Toast-svg/Error.svg" className="imageSize" alt="Error" />;
        if (type === 'warn')
          return <img src="/manage/images/Toast-svg/Warn.svg" className="imageSize" alt="Warn" />;
      }}
    />
    <App />
    
  </Provider>,
);
